/**
 * 环境变量
 */
enum NodeEnvType {
    开发环境 = 'debug',
    生产环境 = 'production',
    测试环境 = 'test',
    演示环境 = 'demo',
    腾讯演示环境 = 'tdemo',
}

export default NodeEnvType;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/NodeEnvType/index.ts